import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, AppBar, Toolbar, IconButton, Typography, TextField, CircularProgress } from '@material-ui/core'
import { show, update, change, success as changeSuccess } from '../../../../store/actions/menor.gestao.action'
import { changeScreenC } from '../../../../store/actions/navigation.action'
import { changeAlert } from '../../../../store/actions/alert.action'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaSave } from 'react-icons/fa'
import MaskedInput from 'react-text-mask' 

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [];

    if (props.name === 'int') {
        mask = [/[0-9]/, /\d/]
    }

    if (props.name === 'perc') {
        mask = [/[0-9]/, '.', /\d/, /\d/, /\d/]

        if (other.value) {
            let valid = other.value.replace('.', '')
            if (valid.length > 3) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/]
            }
        }
    }

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

export default function MenorGestaoEdit(props) {
    const dispatch = useDispatch()
    const { cota } = useSelector(state => state.menorGestaoReducer)
    const campaign_id = (props.campaign_id) ? props.campaign_id : null
    const view = (props.view) ? props.view : null
    const id = (props.uid) ? props.uid : null;
    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        dispatch(show(id)).then(() => setLoading(false))
        return () => {
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _save = () => {
        dispatch(update({
            'id' : id,
            'campaign_id' : campaign_id,
            'percent' : document.getElementById('percent') ? document.getElementById('percent').value : null,
            'min_amount' : document.getElementById('min_amount') ? document.getElementById('min_amount').value : null,
            'max_amount' : document.getElementById('max_amount') ? document.getElementById('max_amount').value : null
        }, view))
    }

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreenC({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Editar Cota</Typography>

                    <Button 
                        variant="contained" 
                        size="small"
                        onClick={() => _save()}
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaSave />}
                    >
                        Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
            <>
                <div className="card card-body mt-2 bs-bg">
                    <div className="mb-3">
                        <small className="d-block bs-color">Cota</small>
                        <h3 className="fw-bold bs-color-b">{cota.quota_number}</h3>
                    </div>

                    <div className="mb-3">
                        <label className="label-custom bs-color-b">Porcentagem</label>
                        <TextField
                            id="percent"
                            name="perc"
                            type="tel"
                            InputProps={{
                                inputComponent: TextMaskCustom,
                                value: String(cota.percent),
                                placeholder: 'ex: 70.05',
                                onChange: text => dispatch(change({ percent: text.target.value }))
                            }}
                        />
                    </div>

                    <div className="mb-3">
                        <label className="label-custom bs-color-b">Valor Minimo</label>
                        <TextField
                            id="min_amount"
                            name="int"
                            type="tel"
                            InputProps={{
                                inputComponent: TextMaskCustom,
                                value: cota.min_amount > 0 ? cota.min_amount : '',
                                placeholder: 'ex: 20',
                                onChange: text => {
                                    if(text.target.value > 50) {
                                        dispatch(changeAlert({
                                            open: true,
                                            msg: 'Limite maximo até 50 reais',
                                            class: 'error'
                                        }))
                                        dispatch(change({ min_amount: '' }))
                                    } else {
                                        dispatch(change({ 
                                            min_amount: text.target.value,
                                            max_amount: null
                                        }))
                                    }
                                }
                            }}
                        />
                    </div>

                    <div className="mb-3">
                        <label className="label-custom bs-color-b">Valor Máximo</label>
                        <TextField
                            id="max_amount"
                            name="int"
                            type="tel"
                            InputProps={{
                                inputComponent: TextMaskCustom,
                                value: cota.max_amount > 0 ? cota.max_amount : '',
                                placeholder: 'ex: 20',
                                onChange: text => {
                                    if(text.target.value > 50) {
                                        dispatch(changeAlert({
                                            open: true,
                                            msg: 'Limite maximo até 50 reais',
                                            class: 'error'
                                        }))
                                        dispatch(change({ max_amount: '' }))
                                    } else {
                                        dispatch(change({ 
                                            min_amount: null,
                                            max_amount: text.target.value 
                                        }))
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </>
            }
            </div>
        </>
    )
}